import { render, staticRenderFns } from "./fancyEditTableItem.vue?vue&type=template&id=3039f346&scoped=true"
import script from "./fancyEditTableItem.vue?vue&type=script&lang=js"
export * from "./fancyEditTableItem.vue?vue&type=script&lang=js"
import style0 from "./fancyEditTableItem.vue?vue&type=style&index=0&id=3039f346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3039f346",
  null
  
)

component.options.__file = "fancyEditTableItem.vue"
export default component.exports